module.exports = __webpack_public_path__ + "img/tomato-field.54970c8f.jpg";